// extracted by mini-css-extract-plugin
export default {"controlWifiCont":"control-wifi_controlWifiCont__j6ZsP","header":"control-wifi_header__6yvTY"};